import ShopOrderPagingResultModelBase from '../_generated/modelBases/shop-order-paging-result-model-base';

export default class ShopOrderPagingResultModel extends ShopOrderPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
